import { render, staticRenderFns } from "./TransferHandle.vue?vue&type=template&id=6972586c&scoped=true"
import script from "./TransferHandle.vue?vue&type=script&lang=js"
export * from "./TransferHandle.vue?vue&type=script&lang=js"
import style0 from "./TransferHandle.vue?vue&type=style&index=0&id=6972586c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972586c",
  null
  
)

export default component.exports